<div class="container d-flex justify-content-center">
    <span class="loader"></span>
</div>
